export function authorEntitiesSelector(state) {
  return state.entities.authors
}
